import QTable from 'quasar/src/components/table/QTable.js';

export function getTransactionColumnsInAdmin(): QTable['columns'] {
  return [
    {
      name: 'id',
      field: 'id',
      label: 'شماره تراکنش',
      align: 'center'
    },
    {
      name: 'description',
      field: 'description',
      label: 'توضیحات',
      align: 'left',
      style: 'max-width:200px;'
    },
    {
      name: 'gateway',
      field: 'gateway',
      label: 'نوع درگاه',
      align: 'center'
    },
    {
      name: 'status',
      field: 'status',
      label: 'مبلغ',
      align: 'center'
    },
    {
      name: 'amount',
      field: 'amount',
      label: 'مقدار',
      align: 'center'
    },
    // {
    //   name: 'from-wallet',
    //   field: 'from-wallet',
    //   label: 'کیف پول',
    //   align: 'left'
    // },
    {
      name: 'ref_id',
      field: 'ref_id',
      label: 'شماره ارجاع',
      align: 'left',
      style: 'max-width:100px;'
    },
    // {
    //   name: 'card_number',
    //   field: 'card_number',
    //   label: 'شماره کارت',
    //   align: 'left'
    // },
    {
      name: 'user',
      field: 'user',
      label: 'کاربر',
      align: 'left',
      style: 'max-width:120px;'
    },
    {
      name: 'paid_at',
      field: 'paid_at',
      label: 'تاریخ پرداخت',
      align: 'left'
    },
    {
      name: 'actions',
      field: 'actions',
      label: 'عملیات',
      align: 'center'
    }]
}


